import { Button } from "@mantine/core";
import { TbLink } from "react-icons/tb";
import { PATREON_CLIENT_ID, PATREON_OAUTH_REDIRECT_URI } from "@/config";

export function LinkPateronButton() {
  return (
    <Button
      component="a"
      href={`https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${PATREON_CLIENT_ID}&redirect_uri=${PATREON_OAUTH_REDIRECT_URI}`}
      leftSection={<TbLink />}
      variant="outline"
    >
      Link Patreon account
    </Button>
  );
}
